import { render } from "./UserAccount.vue?vue&type=template&id=d574e084&scoped=true&ts=true"
import script from "./UserAccount.vue?vue&type=script&lang=ts"
export * from "./UserAccount.vue?vue&type=script&lang=ts"

import "./UserAccount.vue?vue&type=style&index=0&id=d574e084&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d574e084"]])

export default __exports__